module.exports = __webpack_public_path__ + "static/media/ic_reward.7605f2d7.svg";